function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    width: 10,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m7.28,10.01h.02c.27,0,.52-.1.7-.29l1.36-1.36c.05-.05.08-.1.11-.16s.04-.12.04-.19-.02-.13-.04-.19-.06-.12-.11-.16l-2-2c-.05-.05-.1-.08-.16-.11s-.12-.04-.19-.04-.13.02-.19.04-.12.06-.16.11l-.8.8c-.37-.11-1.06-.36-1.5-.8s-.68-1.13-.8-1.5l.8-.8s.08-.1.11-.16.04-.13.04-.19-.02-.13-.04-.19-.06-.12-.11-.16L2.36.65c-.09-.09-.23-.14-.35-.14s-.26.05-.35.14L.29,2.01c-.19.19-.29.45-.29.72,0,.71.2,3.18,2.15,5.13,1.95,1.95,4.43,2.13,5.13,2.15h0ZM2,1.71l1.29,1.29-.65.65c-.06.06-.1.13-.13.21s-.02.17,0,.24c0,.06.31,1.43,1.13,2.25s2.19,1.13,2.25,1.13c.08.02.17.02.24,0s.15-.07.21-.12l.65-.65,1.29,1.29-1,1c-.63,0-2.76-.18-4.43-1.86-1.67-1.67-1.84-3.81-1.85-4.42l1-1h0Zm7,2.79h1c0-2.57-1.93-4.5-4.51-4.5v1c2.03,0,3.51,1.48,3.51,3.5h0Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5,3.01c1.05,0,1.5.45,1.5,1.5h1c0-1.62-.89-2.5-2.5-2.5,0,0,0,1,0,1Z",
    style: {
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2c179c23.svg";
export { ForwardRef as ReactComponent };